import { http } from "../../../shared/api/http";
import { AuthRequest, LoginResponse } from "../models/type";

export async function logoutStaff(): Promise<any> {
  const res = await http.post(`/auth/staff/logout`);
  return res.data;
}